import { Partipant } from "@ac-expo/api-types";
import { getRoleLabel } from "@ac-expo/utils";
import { cn } from "../../../utils";

type ConversationHeaderProps = {
  participant: Partipant;
  pictureUrl?: string;
  fromBackoffice?: boolean;
};

export function ConversationHeader({
  participant,
  pictureUrl,
  fromBackoffice,
}: ConversationHeaderProps) {
  return (
    <div className="flex items-center gap-4 border-b p-4">
      <img
        src={pictureUrl ? pictureUrl : "/images/anonymous_avatar.svg"}
        alt={"profile"}
        className="aspect-square size-12 rounded-full"
      />
      <div className="flex w-full justify-between">
        <div className="flex flex-col gap-1">
          <p className="text-sm font-bold">
            {participant.id === "AC-EXPO"
              ? "Connect'Events"
              : `${participant.firstName} ${participant.lastName}`}
          </p>
          <p className="max-w-40 truncate text-sm font-semibold">
            {participant.businessName}
          </p>
        </div>
        <div className="flex flex-wrap gap-1">
          {participant.roles &&
            participant.roles.map((roleObject) => (
              <p
                key={roleObject.role}
                className={cn(
                  "h-fit w-min text-nowrap rounded-full border bg-slate-200 px-2 text-xs",
                  {
                    "bg-white": fromBackoffice,
                  }
                )}
              >
                {roleObject.role === "acExpo"
                  ? "SAV"
                  : getRoleLabel(roleObject.role)}
              </p>
            ))}
        </div>
      </div>
    </div>
  );
}

export default ConversationHeader;
